import React from 'react';
import JiraBaseRedirect from '@atlassian/jira-spa-apps-common/src/redirect/jira-base-routing';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => <JiraBaseRedirect />;
